import {
    AfterViewChecked,
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Optional
} from '@angular/core';

import {
    getPrettyPropertyRecordCalculationStatus,
    getCalculationStatusActualityById
} from '../../../../../../shared/enums';

import IZoningCodeCalculationStatistic = ZoningAPI.IZoningCodeCalculationStatistic;
import * as _ from 'lodash';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ZoningCodeVersion } from 'src/app/modules/instance/models/zoning-code-version';

@Component({
    standalone: false,
    selector: 'app-zc-version-details-view',
    templateUrl: './zc-version-details-view.component.html',
    styleUrls: ['./zc-version-details-view.component.scss']
})
export class ZCVersionDetailsViewComponent implements OnInit, OnDestroy, AfterViewChecked {
    getCalculationStatusActualityById;
    getPrettyPropertyRecordCalculationStatus;

    isOpenChart = false;
    @Input()
    zcVersionStatistic: IZoningCodeCalculationStatistic;

    @Input()
    zoningCodeVersion: ZoningCodeVersion;

    @Input()
    stateEnv: string;

    private destroy$ = new Subject<boolean>();

    constructor(
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: IZoningCodeCalculationStatistic,
        private cdRef: ChangeDetectorRef
    ) {
        this.getCalculationStatusActualityById = getCalculationStatusActualityById;
        this.getPrettyPropertyRecordCalculationStatus = getPrettyPropertyRecordCalculationStatus;
    }

    ngOnInit() {
        this.zcVersionStatistic = _.get(this, 'data.zcVersionStatistic') || this.zcVersionStatistic;
        this.zoningCodeVersion = _.get(this, 'data.zoningCodeVersion') || this.zoningCodeVersion;
        this.stateEnv = _.get(this, 'data.stateEnv') || this.stateEnv;
    }

    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    summaryStatistic({ statsByStatus }) {
        return statsByStatus.reduce(
            function(accumulator, statistic) {
                return {
                    count: accumulator.count + statistic.count,
                    ratio: Number((accumulator.ratio + statistic.ratio).toFixed(2))
                };
            },
            { count: 0, ratio: 0 }
        );
    }

    statusFormatter(calculationStatusCode: number) {
        return getPrettyPropertyRecordCalculationStatus(calculationStatusCode);
    }
}
